/**
 * One card per relevant program for dashboard child cards.
 * Prefers open cohorts; when multiple incomplete, shows newest cohort only.
 */
export function getCardItems(children: any[]): any[] {
    if (!Array.isArray(children)) return [];
    const items: any[] = [];
    for (const child of children) {
        const programs = child?.programs;
        if (!Array.isArray(programs) || programs.length === 0) continue;

        const cohortOpen = (p: any) => p?.cohort && p.cohort.status === true;

        const incompleteAll = programs.filter((p: any) => p.isPaid && !p.isCompleted);
        const incompleteInOpenCohort = incompleteAll.filter((p: any) => cohortOpen(p));
        const incompleteToConsider = incompleteInOpenCohort.length > 0 ? incompleteInOpenCohort : incompleteAll;

        let relevantPrograms: any[] = [];
        if (incompleteToConsider.length > 0) {
            const maxCohortId = Math.max(...incompleteToConsider.map((p: any) => p.cohortId || 0), 0);
            relevantPrograms =
                maxCohortId > 0
                    ? incompleteToConsider.filter((p: any) => (p.cohortId || 0) === maxCohortId)
                    : incompleteToConsider;
        } else {
            const completed = programs.filter((p: any) => p.isPaid && p.isCompleted);
            if (completed.length > 0) {
                const sorted = [...completed].sort((a: any, b: any) => (b.id || 0) - (a.id || 0));
                relevantPrograms = [sorted[0]];
            }
        }

        for (const program of relevantPrograms) {
            items.push({ ...child, programs: [program], _fullChild: child });
        }
    }
    return items;
}

export function getChildStatus(child: any, program?: any): string {
    const programs = child?.programs;
    if (!Array.isArray(programs) || programs.length === 0) return 'Incomplete';
    const p = program || programs[programs.length - 1];
    if (p?.isCompleted) return 'Completed';
    if (p?.isPaid) {
        const cohort = p?.cohort;
        if (cohort && cohort.access === false) return 'Inactive';
        if (cohort && cohort.status === false) return 'Paused';
        return 'Active';
    }
    return 'Incomplete';
}

export const statusBadgeClass: Record<string, string> = {
    Completed: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    Active: 'bg-sky-50 text-sky-700 border-sky-100',
    Inactive: 'bg-orange-50 text-orange-700 border-orange-100',
    Incomplete: 'bg-amber-50 text-amber-800 border-amber-100',
    Paused: 'bg-slate-100 text-slate-600 border-slate-200',
};
